import React from 'react';

export default function Gold() {
	return (
		<g>
			<path fill="#FFDB80" d="M143.50821,377.37881l-38.77338-29.11682c-0.71062-0.53366-1.60537-0.76047-2.48439-0.62976
				l-33.84924,5.03256c-1.24831,0.18561-2.28378,1.06223-2.67282,2.26282l-7.73633,23.87454
				c-0.43334,1.33728,0.02158,2.80258,1.13608,3.65933l39.92744,30.69324c0.70879,0.54489,1.60722,0.78119,2.49237,0.65561
				l47.06801-6.67871c1.98788-0.28207,3.27362-2.2489,2.73442-4.18292l-6.63649-23.80487
				C144.51732,378.43878,144.09349,377.81833,143.50821,377.37881z" />
			<path fill="#FFEAAE" d="M144.71382,379.14389c-0.19653-0.70499-0.62054-1.32565-1.20561-1.76498l-38.77336-29.11676
				c-0.71083-0.53369-1.60551-0.76083-2.48428-0.62979l-33.84933,5.03256c-0.02683,0.00372-0.04993,0.01801-0.07679,0.0228
				l36.02736,26.97775c3.8691,2.89587,8.735,4.12558,13.51544,3.41461l26.85093-3.92126L144.71382,379.14389z" />
			<path fill="#F9C764" d="M97.37881,379.10468L65.50455,355.6185l-7.51266,23.18356
				c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l39.92731,30.69333c0.66545,0.51132,1.49833,0.73846,2.32993,0.66232
				l4.12333-17.35672C108.08715,385.65253,103.61358,383.80185,97.37881,379.10468z" />
			<path fill="#FFDB80" d="M88.07377,385.32605L49.30039,356.2092c-0.71062-0.53363-1.60537-0.76044-2.48439-0.62976L12.96676,360.612
				c-1.24831,0.18561-2.28379,1.06223-2.67282,2.26282l-7.73633,23.87454c-0.43334,1.33731,0.02158,2.80258,1.13608,3.65933
				l39.92744,30.69327c0.70879,0.54486,1.60722,0.78119,2.49238,0.65558l47.068-6.67871
				c1.98788-0.28204,3.27361-2.24887,2.73443-4.18292l-6.6365-23.80484C89.08288,386.38602,88.65906,385.76556,88.07377,385.32605z" />
			<path fill="#FFEAAE" d="M89.27938,387.09109c-0.19653-0.70499-0.62054-1.32562-1.20561-1.76495l-38.77336-29.11679
				c-0.71083-0.53369-1.60551-0.76083-2.48429-0.62976l-33.84933,5.03253c-0.02683,0.00372-0.04993,0.01801-0.07679,0.0228
				l36.02736,26.97775c3.8691,2.89587,8.735,4.12558,13.51544,3.41461l26.85093-3.92126L89.27938,387.09109z" />
			<path fill="#F9C764" d="M41.94438,387.05188L10.07011,363.5657l-7.51266,23.18356
				c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l39.92732,30.69333c0.66545,0.51132,1.49833,0.73846,2.32993,0.66235
				l4.12333-17.35675C52.65271,393.59973,48.17914,391.74905,41.94438,387.05188z" />
			<path fill="#FFDB80" d="M113.15673,348.82916l-34.14889-25.53934c-0.71062-0.53363-1.60537-0.76044-2.4844-0.62976
				l-33.84923,5.03259c-1.24831,0.18558-2.28379,1.06223-2.67282,2.26279l-7.73633,23.87457
				c-0.43334,1.33728,0.02158,2.80258,1.13608,3.6593l35.30294,27.11575c0.70879,0.54486,1.60722,0.78119,2.49238,0.65558
				l47.068-6.67868c1.98788-0.28207,3.27362-2.2489,2.73443-4.18295l-6.6365-23.80484
				C114.16583,349.88913,113.74201,349.26868,113.15673,348.82916z" />
			<path fill="#F9C764" d="M67.02734,350.55502l-27.24979-19.90881l-7.51266,23.18353
				c-0.43329,1.33734,0.02172,2.80264,1.13636,3.65942l35.30284,27.11597c0.66545,0.51132,1.49832,0.73846,2.32993,0.66235
				l4.12333-17.35675C77.73566,357.10287,73.2621,355.25217,67.02734,350.55502z" />
			<path fill="#FFEAAE" d="M114.36234,350.59424c-0.19653-0.70502-0.62054-1.32565-1.20561-1.76498l-34.14888-25.53943
				c-0.71083-0.53369-1.60551-0.7608-2.48428-0.62976l-33.84933,5.03253c-0.02683,0.00372,31.3261,23.42322,31.3261,23.42322
				c3.86909,2.89587,8.73499,4.12555,13.51544,3.41458l26.85092-3.92126L114.36234,350.59424z" />
			<path fill="#FFF3D7" d="M68.01085,346.64139c3.53385,2.64017,5.98946,4.47461,5.98946,4.47461
				c1.19722,0.89594,2.49728,1.61172,3.85281,2.1806l0.70252-30.28055c-0.62093-0.32706-1.32911-0.46094-2.032-0.3558
				l-7.98396,1.18674L68.01085,346.64139z" />
			<path fill="#FFF3D7" d="M81.77532,354.44876c1.63864,0.28305,3.31666,0.33356,4.99493,0.15491l0.58171-25.07343l-4.91327-3.67438
				L81.77532,354.44876z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Gold.js